// Языки интерфейса — из locales/manifest.json (генерирует i18n/tool из i18n/languages.yaml).
// status: on — в переключателе, по IP и по родному языку; beta — только явно (?lang=xx).
import manifest from '../locales/manifest.json'

export interface UiLanguage {
  code: string
  db_id: number | null
  status: 'on' | 'beta' | 'off'
  dir: 'ltr' | 'rtl'
  endonym: string
  locale: string
  plural: string[]
}

export const UI_LANGUAGES = manifest.languages as UiLanguage[]
export const SOURCE_LANG = manifest.source       // ru — тексты прямо в коде
export const FALLBACK_LANG = manifest.fallback   // en
export const PSEUDO_LANG = 'xx'                  // псевдолокаль: видно неразмеченное и обрезки

export const langInfo = (code: string | null | undefined): UiLanguage | undefined =>
  UI_LANGUAGES.find((l) => l.code === code)

/** Язык в переключателе и для автоматического выбора (IP, родной язык). */
export const isListedLang = (code: string | null | undefined) => langInfo(code)?.status === 'on'

/** Язык можно включить явно (в т. ч. beta и псевдолокаль). */
export const isLoadableLang = (code: string | null | undefined) =>
  code === PSEUDO_LANG || (!!langInfo(code) && langInfo(code)!.status !== 'off')

export const listedLanguages = () => UI_LANGUAGES.filter((l) => l.status === 'on')

export const codeByDbId = (id: number | null | undefined) =>
  id == null ? undefined : UI_LANGUAGES.find((l) => l.db_id === id)?.code

export const dbIdByCode = (code: string | null | undefined) => langInfo(code)?.db_id ?? undefined

/** Название языка на нём самом (эндоним): Intl.DisplayNames, иначе из manifest. */
export function endonym(code: string): string {
  try {
    const n = new Intl.DisplayNames([code], { type: 'language' }).of(code)
    if (n && n !== code) return n.charAt(0).toLocaleUpperCase(code) + n.slice(1)
  } catch {
    /* старый движок без Intl.DisplayNames */
  }
  return langInfo(code)?.endonym ?? code
}
